import { createSelector } from 'reselect';

/**
 * Direct selector to the connection state domain
 */
const selectConnectionManagerDomain = (state) => state.get('connection');

/**
 * Other specific selectors
 */

/**
 * Default selector used by ConnectionManager
 */

const makeSelectConnectionManager = () => createSelector(
  selectConnectionManagerDomain,
  (substate) => substate.toJS()
);

export default makeSelectConnectionManager;
export {
  selectConnectionManagerDomain,
};
